.container {
  min-height: calc(var(--mirai-ui-space-L) * 4.75);
  padding: 0;
}

.checkout {
  height: calc(var(--mirai-ui-space-XXL) * 8.75);
  width: 100%;
}
